export default __webpack_public_path__ + "static/media/Accelerons2017.84869e27.png";